export default __webpack_public_path__ + "static/media/CNo.67-4.9fb63133.jpg";